import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { toggleInfoModal } from '../../../shared/info-modal/actions/info-modal-actions';

import constants, { WIDGETS_BASE_URL } from '../../../../common/constants';
import { TOP_TRADERS_TYPE_FILTER, TOP_TRADERS_TIME_SPAN_FILTER } from '../constants/widget-constants';
import Helpers from '../../../../common/helpers';

import '../styles/top-traders.css';

class TopTraders extends Component {
  state = {
    selectedMainFilter: 'total_net_profit',
    selectedTimeSpan: 'all_time',
    selectedCampaign: '',
  };

  componentDidMount = () => {
    const { campaigns } = this.props;

    if (!isEmpty(campaigns)) {
      this.setState({ selectedCampaign: campaigns[0].partner_code });
    }
  };

  componentDidUpdate = prevProps => {
    const { campaigns } = this.props;
    if (isEmpty(prevProps.campaigns) && !isEmpty(campaigns)) {
      this.setState({ selectedCampaign: campaigns[0].partner_code });
    }
  };

  handleOnMainFilterChange = e => {
    this.setState({ selectedMainFilter: e.currentTarget.value });
  };

  handleOnTimeSpanChange = e => {
    this.setState({ selectedTimeSpan: e.currentTarget.value });
  };

  handleOnCampaignChange = e => {
    this.setState({ selectedCampaign: e.currentTarget.value });
  };

  copyToClipboard = e => {
    const { toggleInfoModal } = this.props;
    const { html } = e.currentTarget.dataset;

    Helpers.copyToClipboard(html);
    toggleInfoModal(true, constants.info_modal_types.success.value, 'DASHBOARD.COPY_BANNER_CODE_MESSAGE');
  };

  render = () => {
    const { t } = this.context;
    const { campaigns } = this.props;
    const { selectedMainFilter, selectedTimeSpan, selectedCampaign } = this.state;
    const widgetUrl = `${WIDGETS_BASE_URL}/top-traders/top-traders-widget.html?refCode=${selectedCampaign}&type=${selectedMainFilter}&time=${selectedTimeSpan}`;
    const html = `<iframe src="${widgetUrl}" title="top-traders" width="400" height="320" frameBorder="none" />`;

    return (
      <div className="top-traders">
        <div className="top-traders__filters">
          <div>
            <span>{t('BANNERS.SELECT_CAMPAIGN')}</span>
            <select className="form-control" value={selectedCampaign} onChange={this.handleOnCampaignChange}>
              {campaigns.map(item => {
                return (
                  <option key={item.partner_code} value={item.partner_code}>
                    {item.link_name}
                  </option>
                );
              })}
            </select>
          </div>
          <div>
            <span>{t('WIDGETS.TOP_TRADERS_MAIN_FILTER')}</span>
            <select className="form-control" value={selectedMainFilter} onChange={this.handleOnMainFilterChange}>
              {TOP_TRADERS_TYPE_FILTER.map(item => {
                return (
                  <option key={item.value} value={item.value}>
                    {t(item.text)}
                  </option>
                );
              })}
            </select>
          </div>
          <div>
            <span>{t('WIDGETS.TOP_TRADERS_TIME_SPAN')}</span>
            <select className="form-control" value={selectedTimeSpan} onChange={this.handleOnTimeSpanChange}>
              {TOP_TRADERS_TIME_SPAN_FILTER.map(item => {
                return (
                  <option key={item.value} value={item.value}>
                    {t(item.text)}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <iframe src={widgetUrl} title="top-traders" width="400" height="320" frameBorder="none" key={`${selectedMainFilter}_${selectedTimeSpan}`} />

        <pre>
          <code>{html}</code>
        </pre>
        <div className="transparent-btn" data-html={html} onClick={this.copyToClipboard}>
          {t('DASHBOARD.GRAB_BANNER_CODE')}
        </div>
      </div>
    );
  };
}

TopTraders.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  toggleInfoModal: (show, type, message, translations, callback, path, btnText) => {
    dispatch(toggleInfoModal(show, type, message, translations, callback, path, btnText));
  },
});

const mapStateToProps = state => ({
  campaigns: state.campaignsReducer.campaigns || [],
});

export default connect(mapStateToProps, mapDispatchToProps)(TopTraders);



// WEBPACK FOOTER //
// ./src/app/main/widgets/components/top-traders.jsx